// @flow
import React, { Component } from 'react'
import { Route, Switch, Link } from 'react-router-dom'
import { notification } from 'antd';
import moment from 'moment'
import {fetchCalenderRequest} from '../../actions/calenders'
import { Redirect } from 'react-router'
import AccountDropDown from './AccountDropDown'
import history from '../../services/history'
import { Auth } from '../../services/auth'
import { Metadata } from '../../services/metadata'
import SideMenu from '../list-menu'
import DashboardView from '../view-dashboard'
import NewDashboard from '../view-dashboard/new-dashboard'
import EarningsView from '../view-earnings'
import CalendarView from '../view-calendar'
import PositionsView from '../view-positions'
import CalculatorsView from '../view-calculators'
import OrdersView from '../view-orders'
// import AdminView from '../view-admin'
import AdminView from '../Admin'
import CoachingView from '../view-coaching'
import RecordingsView from '../view-coaching/Recordings'
import TicketsContainer from '../customer-support'
import StocksView from '../view-stocks'
import ViewTrades from '../view-trades'
import OwnPositions from '../own-positions'
import categoriesView from '../../components/categories'
import PostCategories from '../../components/categories/postCategories'
import ViewPost from '../../components/categories/ViewPost'
import TradeMarix from '../../components/view-trade-matrix'
import TargetsList from '../list-targets/index'
import LoggedInHeader from './LoggedInHeader'
import adminSettings from '../Admin/adminSettings'
import Settings from '../setup-and-settings'
import ProfileContainer from '../user-profile'
import Checkout from '../shop-pages/checkout'
import PackageDetails from '../shop-pages/PackageDetails'
import PortFolioManager from '../PortFolioManager'
import ChartDashboard from '../ChartDashboard'
import PositionsCharts from '../view-positions/Charts'
import Shop from '../shop-pages'
import metadata from '../../metadata.json'
import PrivacyPolicy from '../static/PrivacyPolicy'
import TermsOfService from '../static/TermsOfService'
import Disclaimer from '../static/Disclaimer'
import RefundPolicy from '../static/RefundPolicy'

import {
  MainLayout,
  HeaderLogo,
  MainHeader,
  HeaderIcon,
  StyledSider,
  UserMenuItem,
  ResetPassModel
} from './style'
import { Layout, Menu, Dropdown, Icon, message, Button, Row, Col, Modal } from 'antd'
import OptionBook from "../option-book/index";
const { Footer } = Layout;

type State = {
  collapsed: boolean,
  auth: Auth,
  user: Metadata
}

type Props = {
  permissions: Object,
  onLogout: void => void
}


class LayoutMain extends Component<Props, State> {

  state: State = {
    collapsed: false,
    auth: new Auth(),
    user: new Metadata(),
    visible: false,
    slider : false
  }
  
  async componentWillMount() {
    try {
      const data = await fetchCalenderRequest();
      if (data) {
        this.checkCalenderItems(data);
      }
    } catch(err) {
    
    }
  }


  checkCalenderItems = (calenderItems) => {
      let calendar = []
      let filteredEvents = this.getClosedNotification();
      const currDate = moment(new Date()).unix();
      calenderItems.forEach(item => {
        const endDay = moment(item.calendarenddate).unix();
        const startDate = moment(item.calendarstartdate).unix();
        if (startDate <= currDate && currDate <= endDay && filteredEvents.indexOf(item.id) === -1) {
          calendar.push(item);
          const args = {
            message: item.title,
            description: (<a href={item.url}>{item.url}</a>),
            duration: 0,
            onClose: () => {
              this.onCloseNotification(item.id);
            }
          };
          setTimeout(() => notification.open(args), 1000);
        }
      });
  }
  
  getClosedNotification = () => {
    let filteredEvents = [];
    try {
      const closedEvents = localStorage.getItem('closedEvents');
      if (closedEvents) {
        filteredEvents = JSON.parse(closedEvents);
        if (Array.isArray(filteredEvents)) {
          return filteredEvents;
        } else {
          localStorage.removeItem('closedEvents');
          filteredEvents = [];
        }
      }
    } catch(err) {

    }
    return filteredEvents;
  }
  
  onCloseNotification = (id) => {
    let filteredEvents = this.getClosedNotification();
    filteredEvents.push(id);
    localStorage.setItem('closedEvents', JSON.stringify(filteredEvents));
  }

  onSlider = () => {
    this.setState({
      slider: !this.state.slider
    })
  }

  onPin = () => {
    this.setState({
      pinned: !this.state.pinned
    })
  }

  onPinClose = () => {
    this.setState({
      slider: false,
      pinned: false
    })
  }

  // --- Toggle Sidebar ---
  toggle = () => this.setState({ collapsed: !this.state.collapsed })

  // --- Logout ---
  handleMenu = (menuItem: Object) => {

    // selected menu item index
    const { key } = menuItem

    if (key === '1') history.replace('/user-profile')
    //else if (key === '3') this.handlePasswordReset()
    else if (key === '4') history.replace('/support')
    else if (key === '6') history.replace('/category-view/help')
    else if (key === '5') this.handleSignOut()
  }

  handlePasswordReset = () => {

    const {
      getUser,
      resetUserPassword
    } = this.state.user

    // get user email : attempt reset : display success / error
    if(getUser){
      getUser()
        .then(resetUserPassword)
        .then((msg: string) => message.info(msg))
        .catch((msg: string) => message.info(msg))
        this.setState({
          visible: false,
        });
    }
  }

  handleSignOut = () => {

    // reset data in redux and clear auth data
    const { auth, user } = this.state
    auth.logout()
    user.logout()
    this.props.onLogout()
    localStorage.clear()
  }

  handleModal = () => {
    this.setState({
      visible: !this.state.visible,
    });
  }

  render() {
    // --- State and Props ---
    const { collapsed, visible, slider, pinned } = this.state
    const { permissions } = this.props
    const isPortfolioTools = permissions.portfolioTools
    const chat = document.getElementById('fc_frame');
    if (chat) {
        chat.style.display = window.location.pathname === '/support' ? 'block' : 'none';
    }
    const userEmail: string = String(localStorage.getItem('user_name'))

    // --- Admin Access Routes ---
    const PrivateRoute = ({ component: Component }): Route => (
      <Route render={(props): Component | Redirect =>
        permissions.admin ? <Component {...props} /> : <Redirect to='/' />
      }/>
    )

    // --- User Dropdown Menu ---
    const menu = (
      <Menu onClick={this.handleMenu}>
        <Menu.Item key='1'>
           <a>
             <Icon type='user' />
             <UserMenuItem>Profile</UserMenuItem>
           </a>
        </Menu.Item>
        { permissions.admin &&
          <Menu.Item key='2'>
            <Link to="/settings">
              <Icon type='setting'/>
              <UserMenuItem>Setup and Settings</UserMenuItem>
            </Link>
          </Menu.Item>
        }
        <Menu.Item key='3'>
          <a>
          <Icon type='safety' />
          <UserMenuItem onClick={this.handleModal}>Reset Password</UserMenuItem>
          </a>
        </Menu.Item>
        <Menu.Item key='4' >
          <a>
          <Icon type="user" />
          <UserMenuItem>Customer Support</UserMenuItem>
          </a>
        </Menu.Item>
        <Menu.Item key='6' >
          <a>
            <Icon type="folder" theme="outlined" />
            <UserMenuItem>Help Documentation</UserMenuItem>
          </a>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key='5'>
          <a>
          <Icon type='logout' />
          <UserMenuItem>Logout</UserMenuItem>
          </a>
        </Menu.Item>
      </Menu>
    )

    return (
      <MainLayout>
        <StyledSider
          trigger={null}
          collapsed={collapsed}
          collapsible>

          <HeaderLogo>
            { !collapsed ? <div>OptionsEDU</div> : <div>EDU</div> }
          </HeaderLogo>
          <div style={{marginTop: 65}}>
            { isPortfolioTools && <AccountDropDown /> }
          </div>
          {/*{ isPortfolioTools && <AccountDropDown /> }*/}
          <SideMenu permissions={permissions} />

        </StyledSider>

        <Layout>

          <MainHeader>
            <HeaderIcon
              type={collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={this.toggle} />

            {/*/!* Version *!/*/}
            {/*{ (permissions.dev || permissions.admin) &&*/}
              {/*<span>v0.4.9 (2018-08-25-12:30)</span>*/}
            {/*}*/}
            <LoggedInHeader/>

            {/* User Menu */}
            <Dropdown overlay={menu}>
              <a className='ant-dropdown-link'>
                {userEmail}
                <Icon type='down' />
              </a>
            </Dropdown>

          </MainHeader>
          <ResetPassModel  title="Reset Password"
                           visible={visible}
                           onCancel={this.handleModal}
                           footer={[<button type="button"
                                            className="ant-btn ant-btn-primary"
                                            onClick={this.handlePasswordReset}>OK</button>,
                                    <button type="button"
                                            onClick={this.handleModal}
                                            className="ant-btn">Cancel</button>]}>
            <p>Are you sure you want to reset password?</p>
          </ResetPassModel>
          <Row className="min-Size">
            { window.location.pathname === '/earnings' &&  <Button type="primary" className={`trad-btn ${slider?'trad-btn-hide':''}`} onClick={this.onSlider}>
              <p className="btn-txt">Trade Targets</p>
            </Button> }
            <Col span={slider && pinned ? 19 : 25}>
              <Switch>
                <Route exact path='/' component={NewDashboard}/>
                <Route exact path='/old-dashboard' component={DashboardView}/>
                <Route path='/privacypolicy' component={PrivacyPolicy}/>
                <Route path='/termsofservice' component={TermsOfService}/>
                <Route path='/refundpolicy' component={RefundPolicy}/>
                <Route path='/disclaimer' component={Disclaimer}/>
                <Route path='/earnings' component={EarningsView}/>
                <Route path='/calendar' component={CalendarView}/>
                <Route path='/coaching/:id' component={RecordingsView}/>
                <Route path='/coaching' component={CoachingView}/>
                <Route path='/trades/:id/:tab?' component={OwnPositions}/>
                <Route path='/trades' component={PositionsView}/>
                <Route path='/user-profile/:tab?' component={ProfileContainer}/>
                <Route path='/calculators' component={CalculatorsView}/>
                <Route path='/category-view/:slug' component={categoriesView}/>
                <Route path='/categories-post/:slug' component={PostCategories}/>
                <Route path='/post/:slug' component={ViewPost}/>
                <Route path='/admin/:tab' component={AdminView}/>
                <PrivateRoute path='/admin-settings' component={adminSettings}/>
                <Route path='/settings/:tab?' component={Settings}/>
                <Route path='/support' component={TicketsContainer}/>
                <Route path='/orders' component={OrdersView}/>
                <Route path='/stocks/:symbol/:tab?' component={StocksView}/>
                <Route path='/stocks' component={StocksView}/>
                <Route path='/trade-matrix' component={TradeMarix}/>
                <Route path='/trade/:id/:tab?' component={ViewTrades}/>
                <Route path='/option-book' component={OptionBook}/>
                <Route path='/shop/:packageId' component={PackageDetails} />
                <Route path='/tradeportfoliomanager' component={PortFolioManager}/>
                <Route path='/trade-dashboard' component={ChartDashboard}/>
                <Route path='/trades-charts' component={PositionsCharts}/>
                <Route path='/checkout' component={Checkout} />
                <Route path='/shop' component={Shop}/>
                <Route render={(): Redirect => <Redirect to='/'/>}/>
              </Switch>
            </Col>
            { window.location.pathname === '/earnings' &&
            <Col className={`trades-slider ${slider ? 'show' : 'hide'} ${pinned ? 'pinned' : ''}`}>
              <div className={'dock-header'}>
                  <p className={'dock-title'}>Earnings Trade Targets</p>
                  <Icon className={'dock-Pin'} type="close" onClick={this.onPinClose}/>
                  <Icon className={'dock-Pin'} type={pinned ? 'pushpin' : 'pushpin-o'} onClick={this.onPin} />
              </div>
              <TargetsList/>
            </Col> }
          </Row>
          <Footer className="footer">
            <div>OptionsEDU, LLC ©{moment().format('YYYY')} | Version : {metadata.version} <br />
              <Link to="/privacypolicy">Privacy Policy </Link> |
              <Link to="/termsofservice"> Terms of Service </Link> |
              <Link to="/refundpolicy"> Refund Policy </Link> |
              <Link to="/disclaimer"> Disclaimer </Link>
            </div>
          </Footer>
        </Layout>
      </MainLayout>
    )
  }
}

export default LayoutMain



// WEBPACK FOOTER //
// ./src/components/layout-main/index.js